import React, { useState, useEffect } from 'react';
import ContenedorSubmenu from './ContenedorSubmenu';
import Post from '../../../../utils/Post';

const ContenedorMenu = (p) => {
    const select = p.select;
    const menu = p.menu;
    const index = p.index;
    const [seleccionado, setseleccionado] = useState('');
    const submenusExistentes = () => {
        let subs_nombres = [];
        let len = menu.submenus.length;
        let subs = menu.submenus;
        for (let i = 0; i < len; i++) {
            let nombre = subs[i].submenu_nombre.toUpperCase();
            if (subs_nombres.includes(nombre)) continue;
            subs_nombres.push(nombre);
        }
        return subs_nombres;
    }

    const submenusNoAgregados = () => {
        let subs = p.submenus;
        let len = subs.length;
        let existentes = submenusExistentes();
        let noAgregados = [];
        for (let i = 0; i < len; i++) {
            if (existentes.includes(subs[i].nombre)) continue;
            noAgregados.push(subs[i]);
        }
        return noAgregados;
    }
    const submenus = submenusNoAgregados();

    const agregarSubmenu = async () => {
        let resp = await Post('secure/relaciones/add', { perfil: menu.perfil_id, menu: menu.menu_id, submenu: seleccionado }, 'POST', p.setloader);
        if (resp.estatus) p.refresh();
    }

    return (
        <div className='bw-1000 round-s bg-light p-2 text-black shadow-sm border border-secondary mb-2 mt-2'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className={`w-100 text-bold text-m text-start`}>
                    <span className={`text-300 text-s me-3`}>Menú </span>{menu.menu_nombre}
                </div>

                {menu.submenus.map((submenu, i) =>
                    <React.Fragment key={p.keyGen()}>
                        <ContenedorSubmenu select={select} submenu={submenu} index={index} abrir={p.abrir} refresh={p.refresh} />
                    </React.Fragment>
                )}

                <div className='w-100 mt-3 text-center text-m text-bold mb-2'>Agregar seccción: <span className='ms-2 text-s text-300'>Seleccione una seccion de la lista y pulse el botón agregar</span> </div>
                <div className='form-group bw-200 mb-2'>
                    <select className='form-control form-control-sm shadow border round-xxl text-center text-bold' value={seleccionado} onChange={(e) => setseleccionado(e.target.value)}>
                        <option value='' >Seleccione una sección</option>
                        {submenus.map((submenu, i) =>
                            <option key={p.keyGen()} value={submenu.id}>{submenu.nombre}</option>
                        )}
                    </select>
                </div>
                <div className='form-group bw-200 mb-2 contenedor'>
                    <button className='w-100 btn btn-sm text-bold btn-warning shadow border border-2 border-dark round-xxl'
                        type='button'
                        onClick={agregarSubmenu}
                        disabled={seleccionado == ""}>Agregar sección</button>
                </div>
            </div>
        </div>
    )
}

export default ContenedorMenu;